/**
 * F18 — `/onboard/new` route.
 *
 * Thin wrapper around `<OnboardingWizardWindow />`. The wizard is also
 * registered as a desktop window in `Win95Desktop.tsx` and opens via the
 * Start menu / desktop icon. This route exists for:
 *   - Direct URL navigation (e.g., the admin-consent return landing).
 *   - Programmatic navigate({ to: '/onboard/new' }) from elsewhere.
 *
 * The wizard renders inside the Win95Desktop chrome (no special
 * fullscreen escape). Per Round 1 ADR-B: NIPE never calls
 * `window.location.href = ms-url` — admin-consent is a user-click link.
 */

import { createFileRoute, useSearch } from '@tanstack/react-router';
import { type ReactElement } from 'react';

import { OnboardingWizardWindow } from '../../components/onboard/OnboardingWizardWindow';
import type { OnboardStep } from '../../components/onboard/types';

export interface OnboardSearchParams {
  step?: OnboardStep;
}

export const Route = createFileRoute('/onboard/new')({
  component: OnboardWizardPage,
  validateSearch: (search: Record<string, unknown>): OnboardSearchParams => ({
    step:
      typeof search.step === 'string'
        ? (search.step as OnboardStep)
        : undefined,
  }),
});

function OnboardWizardPage(): ReactElement {
  const search = useSearch({ from: '/onboard/new' });
  return <OnboardingWizardWindow initialStep={search.step} />;
}
